import birthdayProfileValidatorUtil from './birthday'
import heightProfileValidatorUtil from './height'
import weightProfileValidatorUtil from './weight'
import { PROFILE_KEY } from '../constants'

const profileValidator = {
  [PROFILE_KEY.BIRTHDAY]: birthdayProfileValidatorUtil,
  [PROFILE_KEY.HEIGHT]: heightProfileValidatorUtil,
  [PROFILE_KEY.WEIGHT]: weightProfileValidatorUtil
}

export default profileValidator
